<template>
  <ItemPage
    title="Escolas"
    size="sm"
    :actions="actions"
  >
    <div
      v-if="institutionsView"
      class="fill-height"
    >
      <div class="mx-4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Pesquisa"
          single-line
          hide-details
        />
      </div>
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loading-msg="loadingMsg" />
        </template>
        <div
          v-else
          class="mr-5 ml-5"
        >
          <v-data-table
            :headers="headers"
            :items="institutions"
            :items-per-page="5"
            :search="search"
            item-key="id"
            @click:row="editSchool($event)"
          />
        </div>
      </v-simple-table>
    </div>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import NewInstitutionDialog from './NewInstitutionDialog.vue'
import Load from '@/components/Loading.vue'
import ItemPage from '@/components/pages/ItemPage.vue'
import utils from '@/api/utils.js'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      institutionsView: false,
      institutionsCreate: false,
      item: '',
      newSave: false,
      loading: false,
      loadingSave: false,
      loadingMsg: '',
      loadingSaveMsg: '',
      institutions: [],
      status: '',
      msg: '',
      idschool: undefined,
      search: '',
      headers: [
        {
          text: 'Código',
          align: 'start',
          value: 'code'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar Escola',
          action: this.openNewInstitutionDialog,
          icon: 'mdi-plus',
          disabled: !this.institutionsCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.institutionsView = utils.checkPermissions('institutions.view-any')
      this.institutionsCreate = utils.checkPermissions('institutions.create')
      this.getInstitutions()
    },
    checkPermission (permission) {
      return utils.checkPermissions(permission)
    },
    async getInstitutions () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        const school = await this.$api.getSchool()
        this.institutions = school
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível listar as escolas, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editSchool (event) {
      this.$router.push({ name: 'escolas.id', params: { id: event.id } })
    },
    openNewInstitutionDialog () {
      this.$dialog.custom(NewInstitutionDialog).show()
        .then((institution) => {
          if (!institution) {
            return
          }
          this.$router.push({ name: 'escolas.id', params: { id: institution.id } })
        })
    }
  }
}
</script>
